import { css } from "@emotion/react";

import { responsiveBreakpoint } from "@constants";

export const listUl = css`
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    display: flex;
  }
`;

export const listLi = css`
  border-top: 1px solid var(--gray-100);

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    border-top: 0;
    width: 120px;
    margin-right: 10px;
  }

  @media (min-width: ${responsiveBreakpoint[1]}px) {
    width: 140px;
    margin-right: 40px;
  }
`;

export const listNameBox = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const listName = css`
  font-weight: 700;
  font-size: 15px;
  line-height: 56px;
  letter-spacing: -0.2px;
  color: var(--gray-600);
  display: inline-block;

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    line-height: 24px;
    margin-bottom: 10px;
  }
`;

export const itemName = css`
  font-weight: 400;
  font-size: 14px;
  color: var(--gray-600);
  line-height: 40px;
  padding: 6px;
  letter-spacing: -0.2px;
  height: 100%;
  display: block;
  transition: color 0.2s ease;

  &:hover {
    color: var(--blue-500);
    background-color: var(--blue-50);
  }

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    line-height: 20px;
    position: relative;
    left: -6px;
  }
`;

export const icon = (isOpen: boolean) => {
  const open = css`
    transform: rotateX(180deg);
  `;
  const close = css``;

  return isOpen ? open : close;
};
